export default "__VITE_ASSET__DiKAgQqW__"